import { useTranslation } from "react-i18next";
import { ResponsiveDropdownItem } from "@components";
import { useMandatorVisibility } from "@helpers";
import AddIcon from "@icons/myicons/plus.svg?react";
import EyeIcon from "@icons/myicons/eye.svg?react";

interface Options {
  hasWatchlists: boolean;
  onAddToDepot: () => void;
  onAddToWatchlist: () => void;
}

export const useSingleSecurityMenuItems = ({
  hasWatchlists,
  onAddToDepot,
  onAddToWatchlist,
}: Options): ResponsiveDropdownItem[] => {
  const { t } = useTranslation();
  const isWatchlistVisible = useMandatorVisibility({
    hideFor: ["kpmg-germany"],
  });

  const items: ResponsiveDropdownItem[] = [
    {
      label: t("addToDepot"),
      testId: "add-to-depot",
      onClick: onAddToDepot,
      icon: <AddIcon width="24px" height="14px" />,
    },
  ];

  if (hasWatchlists && isWatchlistVisible) {
    items.push({
      label: t("addToWatchlist"),
      testId: "add-to-watchlist",
      onClick: onAddToWatchlist,
      icon: <EyeIcon />,
    });
  }

  return items;
};
